import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Rnd, ResizableDelta, RndResizeCallback }  from 'react-rnd'
import { Backdrop } from './ui/Backdrop';
import { __ } from '@src/translation';
import { observer } from 'mobx-react';

const dialogRoot: HTMLElement = document.getElementById('dialog-root') as HTMLElement;
export enum DialogType {
    Panel="panel",
    Alert="alert",
    Error="error",
    Warning="warning",
    Confirm="confirm",
    Info="info",
    Succes="succes"
}

type DialogProps = {
    title: string;
    width?: number | string;
    height?: number | string ;
    open?: boolean;
    onClose: () => void,
    children?: any,
    dialogType?: DialogType,
    icon?: boolean,
    closable?: boolean,
    outsideWindowClickClose?: boolean,
    outsideWindowClickBeep?: boolean,
    className?: string;
    hasFullScreenButton?: boolean;
    maxWidth?: number | string;
    maxHeight?: number | string;
}

type DialogState = {    
    position: {
        x: number,
        y: number
    },
    open?: boolean,
    fullscreen: boolean,
    heigth: number | string,
    width: number | string,
}

// from https://reactjs.org/docs/portals.html
export class Dialog extends React.Component<DialogProps, DialogState> {
    private el: HTMLElement;

    constructor(props: any) {
        super(props);
        this.el = document.createElement('div');
        dialogRoot.appendChild(this.el);

        this.state = {
            position: {
                x: 0,
                y: 0
            },
            open: this.props.open,
            fullscreen: false,
            heigth: this.props.height ? this.props.height : "auto",
            width: this.props.width ? this. props.width : "auto",
        }
        this.dialogBeep = this.dialogBeep.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
        this.center();
    }

    componentDidUpdate(prevProps: DialogProps, prevState: DialogState) {

        if ( (!prevProps.open && this.props.open) || (!prevState.open && this.state.open) ) {
            this.center();           
        }
        else if(this.props.children !== prevProps.children)
        {
            this.center();
        }

        if((this.refs.root as HTMLElement) && prevProps.open === false)
        {
            (this.refs.root as HTMLElement).focus();
        }
        
    }

    componentWillReceiveProps(nextProps: DialogProps)
    {
        if(nextProps.open !== this.props.open)
            this.setState({open: nextProps.open});
    }

    private center() {
        if (!this.refs.root) return;

        this.setState({
            position: {
                x: (window.innerWidth - (this.refs.root as HTMLElement).clientWidth) / 2,
                y: (window.innerHeight - (this.refs.root as HTMLElement).clientHeight) / 2
            }
        })
    }

    componentWillUnmount() {
        dialogRoot.removeChild(this.el);
        window.removeEventListener("resize", this.handleResize);
    }

    onFullScreen() {
        this.setState({
            fullscreen: !this.state.fullscreen,
            position: {
                x: (window.innerWidth - this.maxWidth) / 2,
                y: (window.innerHeight - this.maxHeight) / 2
            }
        },()=> this.center())
       
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        if(this.props.closable !== false)
        {
            this.setState({open: false, heigth: this.props.height ? this.props.height : "auto", width: this.props.width ? this. props.width : "auto"});
        }
        
    }
    
    Open() {
        
        this.setState({open: true});
    }

    handleResize(event:any) {
        this.center();
    }

    private dialogBeep = () => {
        if (this.props.outsideWindowClickBeep!==undefined && this.props.outsideWindowClickBeep===true) {
            var snd = new Audio("data:audio/wav;base64,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");  
            snd.play();
        }
    }
    maxWidth = this.props.maxWidth ? Number(this.props.maxWidth) : window.innerWidth - 50;
    maxHeight = this.props.maxHeight ? Number(this.props.maxHeight) : window.innerHeight - 50;

    render() {

        if (typeof this.state.open !== 'undefined' && !this.state.open) {
            return null;
        }

        var def = undefined;
        let width = (this.state.fullscreen ? window.innerWidth : this.state.width);
        let height = (this.state.fullscreen ? window.innerHeight : this.state.heigth);

        def = {
            x: this.state.position.x,
            y: this.state.position.y,
            width: width,
            height: height,
        }
        var size = {
            width: width,
            height: height,
        }

        //const size = {};
        
        return ReactDOM.createPortal(
            <>
            <Backdrop onClick={this.props.outsideWindowClickClose===undefined || this.props.outsideWindowClickClose===true ? this.onClose.bind(this) : this.dialogBeep.bind(this)} transparent={false}/>
            <Rnd default={def}
                size={size}
                position={this.state.position}
                onDragStop={(e: any, d: any) => { this.setState({ position: {x: d.x, y: d.y} }) }}
                dragHandleClassName="dialog__drag-handle"
                bounds="window"
                minWidth={Math.min(600, window.innerWidth - 100)}
                minHeight={100}
                maxWidth={this.maxWidth}
                maxHeight={this.maxHeight}
                onResizeStop={(e: MouseEvent | TouchEvent, dir: any, elementRef: HTMLDivElement, delta: ResizableDelta, position: any)=> 
                    {this.setState({width:elementRef.clientWidth, heigth: elementRef.clientHeight}, ()=>this.center())}}
                >
                    <div className={"dialog "+ (this.props.className!==undefined ? this.props.className+"Dialog" : "") + (this.state.fullscreen ? "dialog-fullscreen" : "")} role="dialog" tabIndex={-1} ref="root" style={{maxWidth: this.maxWidth, maxHeight: this.maxHeight, display: "flex", flexDirection: "column", width: "100%", height: "100%", boxSizing: "border-box", backgroundColor: "white", border: "1px solid gray", borderRadius: "3px 3px", boxShadow: "2px 2px 5px gray"}}>
                        
                        <div className={"dialog__header " + (this.props.dialogType ? this.props.dialogType : "") + " "+ (this.props.className!==undefined ? this.props.className+"Header" : "")} style={{width: "100%"}}>
                            {
                                this.props.icon
                                ?
                                    <i className="dialog-icon"></i>
                                :
                                null
                            }
                            <div className={"dialog__drag-handle dialog__title "+ (this.props.className!==undefined ? this.props.className+"Title" : "")}>
                                {this.props.title}
                            </div>
                            {
                                this.props.hasFullScreenButton ? <div className="dialog__fullscreen dialog__border-bottom" onClick={this.onFullScreen.bind(this)}>
                                <button className="middle dialog__fullscreen"><i className={this.state.fullscreen ? "far fa-window-restore" : "far fa-window-maximize"} /></button>
                            </div> : null
                            }
                            {
                                this.props.closable === false ? null 
                                :
                                <div className="dialog__close dialog__border-bottom" onClick={this.onClose.bind(this)}>
                                    <button className="middle dialog__close"><i className="fa fa-times" /></button>
                                </div>
                            }
                           
                        </div>

                        <div ref="dialogContent" tabIndex={-1} className={"dialog__content " + (this.props.className!==undefined ? this.props.className+"Content" : "")} style={{width: "100%", flex: 1, display: "flex", flexDirection: "column", overflow: "auto"}}>
                            {this.props.children}
                        </div>

                    </div>
                </Rnd>
                </>
            ,
            this.el,
        );
    }
}


type DialogContentProps = {className?: string;}
export class DialogContent extends React.Component<DialogContentProps, {}> {
    render() {
        return <div className={"dialog__content "+ (this.props.className!==undefined ? this.props.className+"Content" : "")}>
            {this.props.children}
        </div>
    }
}

type DialogIconContentProps = {className: DialogType; textAlign?: any;}
export class DialogIconContent extends React.Component<DialogIconContentProps, {}> {
    render() {
        return (
            <div className="dialog__icon__content">
                <div className={this.props.className} style={{float:"left", width:"34px"}}>
                    <img src={"/img/IKON_SET/DIALOG/"+this.props.className+".png"} alt="" style={{marginTop:"0.3rem"}} />
                </div>
                <div className={"dialog__content "+ (this.props.className!==undefined ? this.props.className+"Content" : "")} style={{float:"initial", textAlign:(this.props.textAlign!==undefined ? this.props.textAlign : "left")}}>
                    {this.props.children}
                </div>                
            </div>
        ) 
    }
}

export class DialogActions extends React.Component<{}, {}> {
    render() {
        return <div className="dialog__actions">
            {this.props.children}
        </div>
    }
}


var dialogContainer: DialogContainer;

interface DialogItem {
    key: any;
    onClose : ()=>void;
    title ?: string;
    dialogProps: DialogProps; 
    dialogCreator : DialogCreator;
}

type DialogContainerState = {
    dialogs: DialogItem[];
}

var dialogKeyCounter = 1;

@observer
export class DialogContainer extends React.Component<{}, DialogContainerState> {
    constructor(props: any) {
        super(props);

        this.state = {
            dialogs: []
        }
        dialogContainer = this;
    }

    addDialog(title: string, dialogContent: JSX.Element | DialogCreator, dialogProps?: any) {
        const dialogKey = dialogKeyCounter++;

        const ret = new Promise((resolve, reject) => {
            const closeCallback = () => {
                const index = this.state.dialogs.findIndex(x => x.key === dialogKey);
                this.state.dialogs.splice(index, 1);
                this.setState({dialogs: this.state.dialogs});
                resolve();
            };

            let dialogCreator;
            if (typeof dialogContent == 'function') {
                dialogCreator = dialogContent;
            } else {
                dialogCreator = (closeCallback:any) => { return dialogContent; }
            }
            const item : DialogItem = { key: dialogKey, onClose: closeCallback, title, dialogProps, dialogCreator };
            this.state.dialogs.push(item);
            this.setState({dialogs: this.state.dialogs});
        });

        return ret;
    }

    render() {
        return <div>
                {
                    this.state.dialogs.map( (item:DialogItem) => {
                        return <Dialog key={item.key} onClose={item.onClose} title={item.title} {...item.dialogProps as any}>{item.dialogCreator(item.onClose)}</Dialog>
    
                    })
                }
            </div>;
    }
}

type DialogCreator = (closeCallback: () => void) => JSX.Element;

export function showDialog(title: string, dialogContent: JSX.Element | DialogCreator, dialogProps?: any) {
    return dialogContainer.addDialog(title, dialogContent, dialogProps);
}

const DEFAULT_ALERT_DIALOG_TITLE = "Figyelmeztetés";

/**
    * Megjelenít egy alertDialogot.
    * @param message Ha csak ezt adjuk meg, akkor "Figyelmeztetés" lesz a fejlécben.
    * @param details A dialógus tartalma. Ha ezt töltjük, akkor a message lesz a dialógus fejléce.
    */

export async function alertDialog(message: string, details?: string) {
    var ret = false;
    //Ha nincs details megadva, akkor a message lesz a tartalom és a cím a default érték
    let dialogTitle = details ? message : __(DEFAULT_ALERT_DIALOG_TITLE);
    await showDialog(dialogTitle, (close) => <>
            <DialogContent>
                {details || message}
            </DialogContent>
            <DialogActions>
                <button className="button success " onClick={() => {ret = true; close();}}>
                    {__("Bezár")}
                </button>
            </DialogActions>
        </>);
    return ret;
}

export async function confirmDialog(title: string, description?: React.ReactNode, okString?: string, cancelString?: string) {
    var ret = false;
    await showDialog(title, (close) => <>
            <DialogContent>
            {description || title}
            </DialogContent>
            <DialogActions>
                <button className="button alert" onClick={close}>
                    <i className="fa fa-times"/> &nbsp;{cancelString || __("Mégse")}
                </button>

                <button className="button success " onClick={() => {ret = true; close();}}>
                    <i className="fa fa-check"/> &nbsp;{okString || "Ok"}
                </button>
            </DialogActions>
        </>);
    return ret;
}

export async function promptDialog(title: string, description?: string, startValue?: string, okString?: string, cancelString?: string): Promise<string | undefined> {
    var ret: string | undefined = undefined;

    await showDialog(title, (close) => <>
            <DialogContent>
                {description || title}
                <input type="text" defaultValue={startValue || ""} onChange={(e) => ret = e.currentTarget.value } />
            </DialogContent>
            <DialogActions>
                <button className="button alert " onClick={() => {ret = undefined; close();}}>
                    <i className="fa fa-times"/> &nbsp;{cancelString || __("Mégse")}
                </button>

                <button className="button success " onClick={() => {ret = ret || ""; close();}}>
                    <i className="fa fa-check"/> &nbsp;{okString || "Ok"}
                </button>
            </DialogActions>
        </>);
    return ret;
}


export type DialogButtonType = { //Amikor tetszőleges nyomógombokat szeretnénk a felugró ablakon elhelyezni, ennek a típusnak a segítségével definiálhatjuk a tömböt
    className?: string; //az adott gombhoz hozzáadódik a megadott osztálynév, esetleg css-ből való formázáskor van jelentősége
    text: string; //A nyomógomb szövege
    value: number; //A nyomógombra való kattintáskor visszaadandó érték, esetleg lehetne any, hogy akár enum is szerepelhessen benne.
    icon?: string;//A nyomógomb szövege előtt szerepltendő ikon neve (font-awasome), csak a konkrét érték az osztálynévbe a "fa fa-" részt a kód beleteszi
}

export async function customDialog(title:string, content:string, dialogType: DialogType, titleIcon: boolean, contentIcon: boolean, width: string | number = "400px", height: string | number = "100%", textAlign: any = "center", outsideWindowClickClose: boolean = false, outsideWindowClickCloseBeep: boolean = false, buttonGroup?: DialogButtonType[]) {
    var ret = 0;
    var button_group: DialogButtonType[] = [];
    if (buttonGroup!==undefined) button_group=buttonGroup
    else {
        if (dialogType===DialogType.Confirm) button_group.push({className:"alert",text:__("Mégsem"),value:0,icon:"times"});
        button_group.push({className:"success",text:"Rendben",value:1,icon:"check"});
    }
    await showDialog(title, (close) => <>
            {contentIcon===false ?
                <DialogContent> {content} </DialogContent> :
                <DialogIconContent className={dialogType} textAlign={textAlign}> {content} </DialogIconContent>          
            }
            <DialogActions>
                {button_group.map((button:DialogButtonType, index:number) => {     
                    return (
                        <button key={index} className={"button custombutton "+(button.className!==undefined ? button.className : "")} onClick={() => {ret = button.value; close();}}>
                            <i className={button.icon!==undefined ? "fa fa-"+button.icon : ""}/> &nbsp;{button.text}
                        </button>
                    ) 
                })}
            </DialogActions>
        </>, {dialogType:dialogType, icon:titleIcon, width:width, outsideWindowClickClose:outsideWindowClickClose, outsideWindowClickCloseBeep:outsideWindowClickCloseBeep});
    return ret;
}

const dialogContainerDiv = document.createElement("div");

ReactDOM.render(<DialogContainer/>, dialogContainerDiv);
